module.exports = __webpack_public_path__ + "fonts/mulish-v11-latin-regular.1e9c794.ttf";